import $ from 'jquery';
import 'slick-carousel';

export default function rolexCPOSliderWatchCover() {
    const $sliderContainers = $('.js-rolex-cpo-watch-cover__slider');

    if (!$sliderContainers.length) {
        return;
    }

    $sliderContainers.each(function eachSlider() {
        const $container = $(this);
        const $slideTarget = $container.find('.js-rolex-cpo-watch-cover__slide');
        if (!$slideTarget.hasClass('slick-initialized')) {
            $slideTarget.slick({
                infinite: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                nextArrow: $container.find('[data-role="slick-navigation-button"].is--next'),
                prevArrow: $container.find('[data-role="slick-navigation-button"].is--prev'),
            });
        }
    });
}
